<template>
    <v-sheet class="eq-slot" :class="{ 'eq-empty': !entry, 'eq-tall': tall }" border rounded>
        <v-tooltip v-if="entry?.tip" activator="parent" location="bottom"
            content-class="item-tip-content" :open-delay="150">
            <item-tip :title="entry.name" :tip="entry.tip" />
        </v-tooltip>
        <div class="eq-label">
            <span>{{ label }}</span>
            <span v-if="set" class="eq-sets">
                <span v-for="v in SETS" :key="v" class="eq-set" :class="{ 'eq-set-on': set === v }"
                    @click.stop="$emit('select-set', v)">{{ v }}</span>
            </span>
        </div>
        <template v-if="entry">
            <div class="eq-name" :title="entry.name">{{ entry.name }}</div>
            <div class="eq-brief">{{ entry.brief }}</div>
        </template>
        <div v-else class="eq-none">Empty</div>
    </v-sheet>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { IndexItem } from '@/items/itemIndex';
import type { Tip } from '@/items/itemTooltip';
import ItemTip from './itemTip.vue';

export type WeaponSet = 'I' | 'II';
export interface SlotEntry { item: IndexItem; name: string; brief: string; tip: Tip | null }

// One worn-gear cell of the Equipment board; `set` renders the in-game I/II
// weapon-set toggle and emits select-set when clicked.
export default defineComponent({
    components: { ItemTip },
    props: {
        label: { type: String, required: true },
        entry: { type: Object as PropType<SlotEntry | undefined>, default: undefined },
        tall: { type: Boolean, default: false },
        set: { type: String as PropType<WeaponSet | undefined>, default: undefined },
    },
    emits: {
        'select-set': (v: WeaponSet) => v === 'I' || v === 'II',
    },
    setup() {
        const SETS: WeaponSet[] = ['I', 'II'];
        return { SETS };
    },
});
</script>

<style scoped>
.eq-slot { width: 128px; min-height: 96px; padding: 6px; cursor: help; display: flex; flex-direction: column; }
.eq-tall { min-height: 160px; }
.eq-empty { opacity: 0.5; cursor: default; }
.eq-label { display: flex; justify-content: space-between; font-size: 0.75rem; color: #999; }
.eq-sets { display: inline-flex; gap: 2px; }
.eq-set { padding: 0 5px; border: 1px solid #555; border-radius: 2px; cursor: pointer; color: #777; line-height: 1.2; }
.eq-set-on { color: #fff; border-color: #ffd27f; background: #7a4a00; }
.eq-name { font-size: 0.8rem; text-align: center; margin-top: auto; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; }
.eq-brief { font-size: 0.7rem; color: #8fd0ff; text-align: center; margin-bottom: auto; }
.eq-none { text-align: center; color: #777; margin: auto 0; }
</style>
